import { Routes } from '@all-hands-hq/plex-graphql-schema';
import { makeStyles } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';

import { ReactComponent as PlexBrandingSvg } from '../../../assets/plex_branding.svg';
import { spacings } from '../../../theme';
import { SharedNavBar } from '../../shared/navigation/SharedNavBar';
import { ButtonColor, PlexButton } from '../../shared/primitives/PlexButton';

interface Props {
  onClose: () => void;
}

export const NavBar = ({ onClose }: Props): React.ReactElement => {
  const classes = useStyles();
  return (
    <SharedNavBar>
      <div className={classes.root}>
        <Link className={classes.plexLogo} to={Routes.HOME_PATH}>
          <PlexBrandingSvg />
        </Link>
        <div>
          <PlexButton
            className={classes.closeButton}
            label={'Close'}
            color={ButtonColor.TransparentBlack}
            onClick={onClose}
          />
        </div>
      </div>
    </SharedNavBar>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flex: 1,
    alignItems: 'center',
  },
  plexLogo: {
    flexShrink: 0,
    width: 260,
    height: 80,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: spacings.xlarge,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  closeButton: {
    marginRight: spacings.xlarge,
  },
}));
